import { makeAutoObservable } from "mobx";
import { makeImmutable, Money } from "../core";
export class DisabledTipInstance {
    constructor() {
        this.kind = "Disabled";
        makeImmutable(this);
    }
    get value() {
        return Money.zero();
    }
    get storageData() {
        return null;
    }
}
export class EnabledTipInstance {
    constructor(params) {
        this.kind = "Enabled";
        this._value = params.value;
        this._description = params.description;
        this._valueType = params.valueType;
        this.automaticSelection = params.automaticSelection;
        makeAutoObservable(this);
    }
    static fromCents(params) {
        return new EnabledTipInstance({
            value: params.cents === null || params.cents <= 0
                ? null
                : Money.fromCents(params.cents),
            description: params.description,
            valueType: params.valueType,
            automaticSelection: params.automaticSelection,
        });
    }
    get value() {
        var _a;
        return (_a = this._value) !== null && _a !== void 0 ? _a : Money.zero();
    }
    get numericValue() {
        var _a, _b;
        return (_b = (_a = this._value) === null || _a === void 0 ? void 0 : _a.asNumber) !== null && _b !== void 0 ? _b : null;
    }
    get description() {
        return this._description;
    }
    get valueType() {
        return this._valueType;
    }
    setValue(value) {
        if (value.leq(Money.zero())) {
            this.resetValue();
        }
        else {
            this._value = value;
        }
    }
    resetValue() {
        this._value = null;
    }
    get storageData() {
        var _a, _b;
        return (_b = (_a = this._value) === null || _a === void 0 ? void 0 : _a.cents) !== null && _b !== void 0 ? _b : null;
    }
}
export const TipInstance = {
    fromStorageData(params) {
        if (params.settings.enabled) {
            return EnabledTipInstance.fromCents({
                cents: params.value,
                description: params.settings.description,
                valueType: params.settings.valueType,
                automaticSelection: params.settings.automaticSelection,
            });
        }
        return new DisabledTipInstance();
    },
};
export const TipInstanceToken = "TipInstance";
